import { useQuery } from '@tanstack/react-query';
import { useState, useCallback } from 'react';
import useHttpClient from './useHttpClient';

export interface INote {
  noteId: {
    native: number;
    partner: number;
  };
  assigneeId: {
    native : number;
  };
  targetDate: string;
  commentCount: number;
  isCompleted: boolean;
  completedDate?: string;
}

export interface INotePayload {
  noteCalled?: boolean;
  noteLoading: boolean;
  noteErr?: Error;
  note?: INote;
  getNote: (noteId: number | string) => void;
}

const useQueryNote = (): INotePayload => {
  const httpClient = useHttpClient();
  const [noteId, setNoteId] = useState<number | string | null>(null);

  const { data, error, isLoading } = useQuery({
    queryKey: ['note', noteId],
    queryFn: async () => {
      if (!noteId) {
        throw new Error('Note ID not set');
      }
      const response = await httpClient.get(`/notes/${noteId}`);
      return response.data as INote;
    },
    enabled: noteId !== null,
  });

  const getNote = useCallback((id: number | string) => {
    setNoteId(id);
  }, []);

  return {
    noteCalled: noteId !== null,
    noteErr: error as Error,
    noteLoading: isLoading,
    note: data,
    getNote,
  };
};

export default useQueryNote;
